module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/8-7c71e55a89f9d842e5574ad609c234fd.jpg";